var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 44,
    rx: 22,
    fill: "#3B82F6",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2504 31C16.6839 31 11.2274 24.6186 11 14H15.792C15.9494 21.7938 19.4821 25.0951 22.2804 25.7758V14H26.7927V20.7217C29.556 20.4324 32.4588 17.3694 33.4382 14H37.9505C37.1985 18.1522 34.0504 21.2152 31.8118 22.4745C34.0504 23.4955 37.6359 26.1672 39 31H34.0329C32.9661 27.7668 30.308 25.2653 26.7927 24.9249V31H26.2504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.1a0d96057b682e21203d9e124139ed92.svg";
export { ForwardRef as ReactComponent };